const getJsonPath = href => {
  const { pathname, search } = window.location;
  return pathname.slice(-1) === '/' ? pathname.slice(0, -1) + '.json' : pathname + '.json' + search;
};

export default getJsonPath;